import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f6b13ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = { class: "modal-card-title is-title-shrink" }
const _hoisted_6 = {
  key: 0,
  class: "button download is-default is-rounded refresh mr-2 ml-2"
}
const _hoisted_7 = { class: "modal-card-body" }
const _hoisted_8 = {
  class: "qrcode-container",
  ref: "qrCode"
}
const _hoisted_9 = { class: "has-text-centered is-size-4 mt-2" }
const _hoisted_10 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_QrCodeVue = _resolveComponent("QrCodeVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$modal.args.value[0].title), 1),
        (_ctx.$platform === 'web')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _createElementVNode("span", {
                class: "icon",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadQrCodePdf && _ctx.downloadQrCodePdf(...args)))
              }, [
                _createVNode(_component_fa_icon, { icon: "download" })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$modal.close()))
        })
      ]),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_QrCodeVue, {
            "render-as": "svg",
            size: 200,
            value: JSON.stringify(_ctx.$modal.args.value[0].data)
          }, null, 8, ["value"])
        ], 512),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$modal.args.value[0].label), 1)
      ]),
      _createElementVNode("footer", _hoisted_10, [
        _createElementVNode("button", {
          class: "button custom-button-modal has-text-weight-medium",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$modal.close()))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Close")), 1)
        ])
      ])
    ])
  ]))
}